import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "vault-list-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "vault-list-header-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mover Documento")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Selecione o Cofre de Destino", -1)
const _hoisted_4 = { class: "vault-list-content" }
const _hoisted_5 = {
  key: 0,
  style: {"margin-left":"20px"}
}
const _hoisted_6 = { class: "vault-list-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Mover Documento")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("span", {
        class: "vault-list-close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModalMoveDocument && _ctx.closeModalMoveDocument(...args)))
      }, [
        _createVNode(_component_CloseOutlined)
      ]),
      _hoisted_2,
      _hoisted_3
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(_component_a_radio_group, {
        value: _ctx.folderSelected,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.folderSelected) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foldersList, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              _createVNode(_component_a_radio, {
                value: item.id,
                style: _normalizeStyle(_ctx.radioStyle),
                disabled: item.id === _ctx.infoDocument?.folderId
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["value", "style", "disabled"]),
              (item.childrens && item.childrens.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childrens, (child) => {
                      return (_openBlock(), _createBlock(_component_a_radio, {
                        key: child.id,
                        value: child.id,
                        style: _normalizeStyle(_ctx.radioStyle),
                        disabled: child.id === _ctx.infoDocument?.folderId
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(child.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "style", "disabled"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("footer", _hoisted_6, [
      _createVNode(_component_a_button, {
        style: {"margin-right":"10px"},
        onClick: _ctx.closeModalMoveDocument
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.moveDocument,
        disabled: !_ctx.folderSelected
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["loading", "onClick", "disabled"])
    ])
  ], 64))
}